import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { StaticMsgModule } from '@lib/pipes';
import { BoardingCertificateSearchSubHeaderComponent } from './boarding-certificate-search-sub-header.component';

@NgModule({
  declarations: [BoardingCertificateSearchSubHeaderComponent],
  imports: [CommonModule, RouterModule, StaticMsgModule],
  exports: [BoardingCertificateSearchSubHeaderComponent],
})
export class BoardingCertificateSearchSubHeaderModule {}
